module.exports = __webpack_public_path__ + "img/bg-jin.bbc3a858.png";